module.exports = __webpack_public_path__ + "static/media/telc.838b4d7d.png";